import { Injectable } from "@angular/core";
import { CSVFileExportResult } from "../../models/domains/pbm/exports/file-export-result";
import { AbstractParser } from "./parser";

@Injectable()
export class ExportFileParser extends AbstractParser<CSVFileExportResult> {
  parse(payload: any): CSVFileExportResult {
    const fileExportResult = new CSVFileExportResult(payload);
    return fileExportResult;
  }
}
